<template>
    <div
        id="slider-main"
        v-if="landingPage.hslider_list && landingPage.hslider_list.length > 0"
    >
        <div class="container">
            <div class="relative-section">
                <img src="../assets/images/sun.png" alt class="sun" />
                <slick ref="slick" :options="slickOptions" class="slider-call">
                    <li
                        v-for="(item, index) in landingPage.hslider_list"
                        :key="index"
                    >
                        <a :href="item.link" class="image-fit">
                            <img :src="item.image" alt />
                            <div class="des font-balo">
                                <h2 v-html="item.des"></h2>
                            </div>
                        </a>
                    </li>
                </slick>
            </div>
        </div>
    </div>
</template>

<script>
import Slick from "vue-slick";
import { mapState } from "vuex";
import { get } from "lodash";
export default {
    name: "LandingSlide",
    components: { Slick },
    data() {
        return {
            slickOptions: {
                infinite: true,
                autoplay: true
            }
        };
    },
    computed: {
        ...mapState({
            landingPage: state => get(state, "app.landingPage")
        })
    },
    watch: {
        // The persisted landing page is replaced when the current language loads;
        // slick keeps its cloned slides unless it is rebuilt.
        "landingPage.hslider_list": function() {
            this.$nextTick(() => {
                if (this.$refs.slick) this.$refs.slick.reSlick();
            });
        }
    }
};
</script>
